import { render, staticRenderFns } from "./assignment-lines-traceability-modal.vue?vue&type=template&id=118f62cc&scoped=true"
import script from "./assignment-lines-traceability-modal.vue?vue&type=script&lang=js"
export * from "./assignment-lines-traceability-modal.vue?vue&type=script&lang=js"
import style0 from "./assignment-lines-traceability-modal.vue?vue&type=style&index=0&id=118f62cc&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "118f62cc",
  null
  
)

export default component.exports